export const enum TrafficType {
	INTERNAL = 'internal',
	EXTERNAL = 'external',
	DEVELOPER = 'developer',
}
